import React from 'react';
import { extractInlineStyles } from '../utils';
import styles from '../RichText.module.scss';
import { RichTextNode } from '../types';

const RichTextUnorderedList = ({ children, value }: RichTextNode) => (
  <ul className={styles.richTextList} style={extractInlineStyles(value)}>
    {children}
  </ul>
);

RichTextUnorderedList.dispayName = 'RichTextUnorderedList';

export default RichTextUnorderedList;
